<template>
	<div class="newDesBox">
		<div class="banner">
		</div>
		<div class="titleList flexBox"></div>
		<div class="desBox">
			<div class="txt ql-editor" v-html="des.content" style="white-space: pre-wrap;"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'pageDes',
		components: {

		},
		data() {
			return {
				des:{}
			}
		},
		mounted() {
			var id = this.$route.query.id;
			if(id != undefined){
				this.$req("get", "/api/cms/page/"+id).then((res) => {
					this.des = res.data
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/newDes.css");
</style>